import playlistThumbnailImg from "../../assets/images/playlist-thumbnail-simplified.png";

export default function PlaylistThumbnail({
  backgroundColor,
  className,
}: {
  backgroundColor: string | null;
  className?: string;
}) {
  const defaultBackground = "var(--color-ds-primary)";
  return (
    <div
      className={`relative size-full overflow-hidden ${className ?? ""}`}
      style={{
        backgroundColor:
          backgroundColor === null ? defaultBackground : backgroundColor,
      }}
    >
      <img
        src={playlistThumbnailImg}
        alt=""
        className="size-full object-cover"
      />
    </div>
  );
}
